export const TEST_ID = 'onboardingFooterText';
